import { Box3 } from 'three';
import { create } from 'zustand';

interface StandingMeshStore {
  standingMeshBoundingBox: Box3 | null;
  setStandingMeshBoundingBox: (boundingBox: Box3) => void;
}

export const useStandingMeshStore = create<StandingMeshStore>((set) => ({
  standingMeshBoundingBox: null,
  setStandingMeshBoundingBox: (boundingBox: Box3) =>
    set({ standingMeshBoundingBox: boundingBox }),
}));
